<template>
  <v-app class="homesync-ref-app">
    <!-- Step 1: Landing Page -->
    <div v-if="step == 1" class="landing-container">
      <div class="content-wrapper">
        <!-- Logo Section -->
        <div class="logo-section">
          <div class="logo-icon">
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- House Icon -->
              <path d="M60 20L20 50V100H50V70H70V100H100V50L60 20Z" fill="white"/>
              <rect x="54" y="35" width="12" height="12" fill="#3949AB"/>
              <rect x="42" y="35" width="8" height="8" fill="#3949AB"/>
              <rect x="70" y="35" width="8" height="8" fill="#3949AB"/>
              <!-- Curved underline -->
              <path d="M30 105Q60 115 90 105" stroke="white" stroke-width="3" fill="none"/>
            </svg>
          </div>
          <h1 class="logo-text">HomeSyncX</h1>
        </div>

        <!-- Main Heading -->
        <div class="main-heading">
          <h2 class="heading-text">
            Join HomeSyncX™ – Transform Your Real Estate Business!
          </h2>
        </div>

        <!-- Description -->
        <p class="description-text">
          HomeSyncX™ is revolutionizing how real estate agents connect with clients and earn commissions.
          Be one of the first to join and unlock exclusive opportunities!
        </p>

        <!-- How to Get Started Section -->
        <div class="steps-section">
          <h3 class="steps-heading">How to Get Started</h3>

          <div class="step-item">
            <span class="step-number">1</span>
            <span class="step-text">Sign up today - it's free!</span>
          </div>

          <div class="step-item">
            <span class="step-number">2</span>
            <span class="step-text">Secure your spot before launch!</span>
          </div>

          <div class="step-item">
            <span class="step-number">3</span>
            <span class="step-text">Get ready to start earning once we go live</span>
          </div>
        </div>

        <!-- CTA Button -->
        <div class="cta-section">
          <v-btn
            x-large
            class="join-btn"
            @click="openSpinWheel"
            elevation="8"
          >
            Join Now →
          </v-btn>
        </div>
      </div>
    </div>

     <!-- Success Step -->
     <div v-if="step == 3" class="success-step">
       <v-row class="justify-center">
         <v-col cols="12" md="8" lg="6">
           <v-card class="pa-8 text-center" elevation="2">
             <v-icon size="80" color="success" class="mb-4">check_circle</v-icon>
             <h2 class="mb-4">🎉 Welcome to HomeSyncX™!</h2>
             <p class="text-h6 mb-4">Your account has been created successfully.</p>
             <p class="mb-6">Check your email for your login credentials and next steps.</p>
             <v-btn
               large
               color="blue"
               @click="$router.push('/login')"
               class="font-weight-bold"
               dark
             >
               Click here to Login   <v-icon class="material-icons-round" style="font-size: 35;">arrow_forward</v-icon>
             </v-btn>
           </v-card>
         </v-col>
       </v-row>
     </div>

     <!-- HomeSyncX Agent Chat Signup -->
     <div v-if="step == 4" class="conversational-step">
       <v-row class="justify-center">
         <v-col cols="12" md="8" lg="6">
           <HomeSyncAgentModal
             :is-open="true"
             :mode="'chat'"
             :user-id="ref_id"
             @close="step = 1"
             @signup-complete="onAgentSignupComplete"
           />
         </v-col>
       </v-row>
     </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import HomeSyncAgentModal from '../Agents/HomeSyncAgentModal.vue'

export default {
    components: {
      HomeSyncAgentModal
    },
    data () {
      return {
        step: 1,
        loadingFlag: true,
        ref_id: null,
        ref_agent: null,
        url: '',
        base_url_img: process.env.VUE_APP_API_BASE_URL_IMG
      }
    },
    mounted() {
      this.ref_id = this.$route.params.id || null
      this.ref_agent = this.$route.params.agent || null
      this.url = window.location.hostname.split('.')[0]
    },
    beforeCreate: function () {
        if (localStorage.getItem('token')) {
            if(localStorage.getItem('is_admin') && localStorage.getItem('is_admin') == 1){
                this.$router.push('/admin/dashboard')
            }else
                this.$router.push('/dashboard')
        }
    },
    methods : {
      openSpinWheel() {
        // Go directly to conversational registration
        this.step = 4;
      },

      onAgentSignupComplete(userData) {
        console.log('HomeSyncX agent signup completed:', userData);

        // Don't change step - keep user in chat interface
        // The chat will show the success message with referral link
        Vue.$toast.success('🎉 Registration completed successfully! Check your email for login credentials.', {
          position: 'top-right'
        });

        // Log referral link for debugging
        if (userData.referral_link) {
          console.log('Referral link:', userData.referral_link);
        }
      },

      scrollToBottom() {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      }
    }
}
</script>

<style scoped>
/* Main App Styling */
.homesync-ref-app {
  background: linear-gradient(180deg, #2C3E7F 0%, #1A2456 100%) !important;
  min-height: 100vh;
}

/* Landing Container */
.landing-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: linear-gradient(180deg, #2C3E7F 0%, #1A2456 100%);
}

.content-wrapper {
  max-width: 700px;
  width: 100%;
  text-align: center;
  padding: 20px;
}

/* Logo Section */
.logo-section {
  margin-bottom: 40px;
}

.logo-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.logo-text {
  font-size: 56px;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0;
  letter-spacing: -1px;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Main Heading */
.main-heading {
  margin-bottom: 30px;
}

.heading-text {
  font-size: 36px;
  font-weight: 700;
  color: #FFFFFF;
  line-height: 1.3;
  margin: 0;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* Description */
.description-text {
  font-size: 20px;
  color: #FFFFFF;
  line-height: 1.6;
  margin: 0 0 50px 0;
  opacity: 0.95;
  font-weight: 400;
}

/* Steps Section */
.steps-section {
  margin-bottom: 50px;
  text-align: left;
}

.steps-heading {
  font-size: 32px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0 0 30px 0;
  text-align: left;
}

.step-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  font-size: 22px;
  color: #FFFFFF;
}

.step-number {
  font-size: 28px;
  font-weight: 700;
  color: #FFFFFF;
  margin-right: 15px;
  min-width: 35px;
}

.step-text {
  font-size: 22px;
  font-weight: 400;
  line-height: 1.5;
  color: #FFFFFF;
}

/* CTA Section */
.cta-section {
  margin-top: 50px;
}

.join-btn {
  background: linear-gradient(135deg, #4CAF50 0%, #45A049 100%) !important;
  color: #FFFFFF !important;
  font-size: 28px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  padding: 20px 60px !important;
  height: 70px !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(76, 175, 80, 0.4) !important;
  transition: all 0.3s ease !important;
}

.join-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(76, 175, 80, 0.5) !important;
}

/* Success Step */
.success-step {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #2C3E7F 0%, #1A2456 100%);
  padding: 40px 20px;
}

.success-step .v-card {
  background: #FFFFFF !important;
}

/* Conversational Step */
.conversational-step {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #2C3E7F 0%, #1A2456 100%);
  padding: 40px 20px;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .logo-text {
    font-size: 42px;
  }

  .heading-text {
    font-size: 28px;
  }

  .description-text {
    font-size: 18px;
  }

  .steps-heading {
    font-size: 26px;
  }

  .step-number {
    font-size: 24px;
  }

  .step-text {
    font-size: 18px;
  }

  .join-btn {
    font-size: 24px !important;
    padding: 16px 40px !important;
    height: 60px !important;
  }
}

@media (max-width: 480px) {
  .landing-container {
    padding: 20px 15px;
  }

  .logo-icon svg {
    width: 80px;
    height: 80px;
  }

  .logo-text {
    font-size: 36px;
  }

  .heading-text {
    font-size: 24px;
  }

  .description-text {
    font-size: 16px;
    margin-bottom: 40px;
  }

  .steps-heading {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .step-item {
    margin-bottom: 15px;
  }

  .step-number {
    font-size: 20px;
    min-width: 30px;
  }

  .step-text {
    font-size: 16px;
  }

  .join-btn {
    font-size: 20px !important;
    padding: 14px 32px !important;
    height: 56px !important;
    width: 100%;
  }
}
</style>

